export function isNonProd() {
  const uatEnv =
    (typeof window !== "undefined" && window.REACT_APP_UAT_ENV) || "";
  return Boolean(uatEnv);
}
